import {createStore, applyMiddleware, compose} from 'redux';
import {rootReducer} from './reduces';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import createHistory from 'history/createBrowserHistory';
import {routerMiddleware } from 'react-router-redux';
export const browserHistory = createHistory();
const historyMiddleware = routerMiddleware(browserHistory);

const middleware = [thunk,historyMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}
let composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION__ ? compose(
  applyMiddleware(...middleware),
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
) : compose(applyMiddleware(...middleware));

export const store = createStore(rootReducer,composeEnhancers);